const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnpqrstuvwxyz';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%&*?';
const ALL = UPPER + LOWER + DIGITS + SYMBOLS;

export const GENERATED_PASSWORD_LENGTH = 14;

function randomIndex(max, cryptoApi) {
  const values = new Uint32Array(1);
  const limit = Math.floor(0x100000000 / max) * max;
  do {
    cryptoApi.getRandomValues(values);
  } while (values[0] >= limit);
  return values[0] % max;
}

export function generateStrongPassword(cryptoApi, length = GENERATED_PASSWORD_LENGTH) {
  const pick = (alphabet) => alphabet[randomIndex(alphabet.length, cryptoApi)];
  const characters = [pick(UPPER), pick(LOWER), pick(DIGITS), pick(SYMBOLS)];
  while (characters.length < length) characters.push(pick(ALL));
  for (let index = characters.length - 1; index > 0; index -= 1) {
    const swap = randomIndex(index + 1, cryptoApi);
    [characters[index], characters[swap]] = [characters[swap], characters[index]];
  }
  return characters.join('');
}
